import { defineComponent as _defineComponent } from 'vue'
import { computed, watch } from 'vue';

import EnterVoucherCode from '@/components/redeem/EnterVoucherCode.vue';
import ShopInfo from '@/components/redeem/shop-details/ShopInfo.vue';
import store from '~store';


export default /*#__PURE__*/_defineComponent({
  __name: 'RegionShopInfoModal',
  setup(__props) {

const { getters } = store;
const shop = computed(() => getters.getShopDetails);
const modal = computed(() => store.state.region.shopModal);

watch(modal, (active) => {
  store.state.region.shopId = active === true
    ? shop.value.id
    : null;
});

return { __sfc: true,getters, shop, modal, EnterVoucherCode, ShopInfo, store }
}

})